var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00098 3H21.001C21.2662 3 21.5205 3.10536 21.7081 3.29289C21.8956 3.48043 22.001 3.73478 22.001 4V20C22.001 20.2652 21.8956 20.5196 21.7081 20.7071C21.5205 20.8946 21.2662 21 21.001 21H3.00098C2.73576 21 2.48141 20.8946 2.29387 20.7071C2.10633 20.5196 2.00098 20.2652 2.00098 20V4C2.00098 3.73478 2.10633 3.48043 2.29387 3.29289C2.48141 3.10536 2.73576 3 3.00098 3ZM15.001 7V9H11.001V11H15.001V13L18.501 10L15.001 7ZM9.00098 17V15H13.001V13H9.00098V11L5.50098 14L9.00098 17Z",
    fill: "#00EEFA",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwap);
export default __webpack_public_path__ + "static/media/ic-swap.848baf44.svg";
export { ForwardRef as ReactComponent };